/**
 * Firebase Configuration — Culp Financial Planner
 *
 * Exports:
 *   db             — Firestore database instance
 *   auth           — Firebase Auth instance
 *   googleProvider — Google OAuth provider
 *   functions      — Cloud Functions instance (for callable functions)
 *   messaging      — Firebase Cloud Messaging instance (null if unsupported)
 */
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFunctions } from "firebase/functions";
import { getMessaging, isSupported } from "firebase/messaging";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
export const functions = getFunctions(app);

// FCM — null on unsupported browsers (Safari iOS, Firefox private, etc.)
let messagingInstance = null;
try {
  // isSupported() is async but getMessaging is sync — guard with try/catch
  messagingInstance = getMessaging(app);
} catch (err) {
  console.warn('[firebase] FCM not supported:', err.message);
}
export const messaging = messagingInstance;

// Async check for templates that need to await support
export const messagingSupported = isSupported();
